import _groupBy from 'lodash/groupBy'
import $ from 'jquery'

export default {
  install (Vue) {
    const getJsonData = function (jsonkey) {
      if (!jsonkey) return
      const resourceEndpoint = (process.env.APP_NODE_ENV || process.env.NODE_ENV) === 'production'
        ? 'https://www.straitstimes.com/multimedia/graphics/json/'
        : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

      const url = resourceEndpoint + jsonkey + '/0.json'
      fetch(url)
      .then(res => res.json())
      .then((jsonkeydata) => {
        if (!jsonkeydata) return

        const updateStr = (datestr) => {
          const lastdate = new Date(datestr.replace(/at.*/, ''))
          const day = lastdate.toLocaleDateString('en-US', {weekday: 'long'})
          var month = lastdate.toLocaleDateString('en-US', {month: 'short'})
          if (lastdate.getMonth() > 1 && lastdate.getMonth() < 7) {
            month = lastdate.toLocaleDateString('en-US', {month: 'long'})
          } else if (month === 'Sep') {
            month = 'Sept'
          }
          return `${day} (${month} ${lastdate.getDate()})`
        }

        const newcases = _groupBy(jsonkeydata, (item) => {
          item.person = 'person'
          if (item.gender === 'male') {
            item.person = 'man'
            if (item.age <= 2) {
              item.person = 'baby boy'
            } else if (item.age < 14) {
              item.person = 'boy'
            }
          } else if (item.gender) {
            item.person = 'woman'
            if (item.age <= 2) {
              item.person = 'baby girl'
            } else if (item.age < 14) {
              item.person = 'girl'
            }
          }
          item.agetext = '?-year-old'
          if (!isNaN(item.age) && item.age !== '') {
            item.agetext = `${item.age < 1 ? Math.floor(item.age * 12) : item.age}-${item.age < 1 ? 'month' : 'year'}-old`
          }
          // if (item.updated === jsonkeydata[0].updated) {
          //   item.isNewCase = 1
          //   return true
          // }
          return false
        })
        const died = _groupBy(jsonkeydata, (item) => {
          return item.condition === 'died'
        })
        var newDied = {true: []}
        // if (died && died.true) {
        //   newDied = _groupBy(died.true, (item) => {
        //     return item.updated === died.true[0]['date-died']
        //   })
        // }
        const localcases = _groupBy(jsonkeydata, (item) => {
          return item['imported or local'] === 'local'
        })
        const conditions = _groupBy(jsonkeydata, (item, key) => {
          return item.condition
        })
        const discharged = _groupBy(jsonkeydata, (item) => {
          var key = ''
          Object.keys(item).some(function (k) {
            if (~k.indexOf('date-discharged')) {
            // if (~k.indexOf('date of being discharged')) {
              key = k
            }
          })
          if (key && item[key]) {
            return true
          }
          return false
        })

        // latestdischargedrecovered
        // cases with date-discharged && condition === 'recovered && on the latest same day under date-discharged
        let latestdischargedrecovered = jsonkeydata
          .filter(d => d.condition && d.condition === 'recovered')
          .filter(d => d['date-discharged'])
          .sort((a, b) => new Date(b['date-discharged']) - new Date(a['date-discharged']))

        latestdischargedrecovered = latestdischargedrecovered.filter((item, i) => {
          const latestDate = new Date(latestdischargedrecovered[0]['date-discharged']).getTime()
          const currentItemDate = new Date(item['date-discharged']).getTime()
          return i === 0 || currentItemDate === latestDate
        })

        var clusters = _groupBy(jsonkeydata, (item) => {
          return item['cluster-group']
        })
        for (const cname in clusters) {
          // when a case belongs to many clusters; distribute to each cluster
          if (cname.includes(';')) {
            const grp = cname.split(';')
            grp.forEach((element, i) => {
              const el = element.trim()
              clusters[cname].forEach((itemcase, idx) => {
                if (clusters[el]) {
                  clusters[el].push(itemcase)
                } else {
                  clusters[el] = [itemcase]
                }
              })
            })
            delete clusters[cname]
          }
        }
        const nocluster = _groupBy(jsonkeydata, function (item) {
          const isPassed = item['28-days-passed'] === 'TRUE' ? true :
                item['28-days-passed'] === 'FALSE' ? false : item['28-days-passed']
          const isLinked = item['link-to-previous-cases-cluster'] === 'TRUE' ? true :
                item['link-to-previous-cases-cluster'] === 'FALSE' ? false : item['link-to-previous-cases-cluster']
          const linkedcase = item['case-connections-within-cluster']
          return (item['imported or local'] === 'local' && isLinked &&
            !item['cluster-group'] &&
            (!linkedcase || (linkedcase && jsonkeydata[linkedcase]['imported or local'] === 'local')) &&
            !isPassed && true)
        })
        const noorigin = _groupBy(jsonkeydata, function (item) {
          const isPassed = item['28-days-passed'] === 'TRUE' ? true :
                item['28-days-passed'] === 'FALSE' ? false : item['28-days-passed']
          return !item['link-to-previous-cases-cluster'] && !isPassed
        })

        // latestunlink
        // cases with update string match last-update string
        // cases with link-to-previous-cases-cluster false
        // const latestunlink = jsonkeydata
        //   .filter(item => item.updated.trim() === jsonkeydata[0]['last-updated'].trim())
        //   .filter(item => !item['link-to-previous-cases-cluster'] || item['link-to-previous-cases-cluster'].toString().trim() === 'FALSE')

        delete clusters['undefined']
        const variabledata = {
        //   lastupdated: updateStr(jsonkeydata[0]['last-updated']),
          numcasesctr: jsonkeydata[0]['case-number'],
          newcases: newcases.true,
          // numnewcasesctr: (newcases.true.length || 0),
        //   lastupdatednewcase: updateStr(jsonkeydata[0].updated),
          died: died.true,
          numdiedctr: !died || !died.true ? 0 : (died.true.length || 0),
          numnewdiedctr: !newDied || !newDied.true ? 0 : (newDied.true.length || 0),
        //   lastupdateddied: died && died.true ? updateStr(died.true[0]['date-died']) : '',
          localcases: localcases.true,
          numlocalcasesctr: (localcases.true.length || 0),
          importedcases: localcases.false,
          numimportedcasesctr: (localcases.false ? localcases.false.length || 0 : 0),
          conditions: conditions,
          numrecoveredctr: conditions && conditions.recovered ? conditions.recovered.length : 0,
          latestdischargedrecovered: latestdischargedrecovered,
        //   latestdischargedrecovereddate: latestdischargedrecovered.length ? updateStr(latestdischargedrecovered[0]['date-discharged']) : '',
          numlatestdischargedrecovered: latestdischargedrecovered.length,
          numdischargedctr: discharged && discharged.true ? discharged.true.length : 0,
          numcriticalctr: conditions && conditions.critical ? conditions.critical.length : 0,
          clusters: clusters,
          numclustersctr: (Object.keys(clusters).length || 0),
          nocluster: nocluster.true || [],
          numnoclusterctr: nocluster && nocluster.true ? nocluster.true.length : 0,
        //   lastupdatednocluster: nocluster && nocluster.true ? updateStr(nocluster.true[0].updated) : '',
          noorigin: noorigin.true,
          numnooriginctr: noorigin && noorigin.true ? noorigin.true.length : 0,
          // latestunlink: latestunlink,
          // numlatestunlink: latestunlink.length
        }
        variabledata.numcasesword = numWord(variabledata.numcasesctr)
        variabledata.numcases = numWordAuto(variabledata.numcasesctr)
        // variabledata.numnewcasesword = numWord(variabledata.numnewcasesctr)
        // variabledata.numnewcases = numWordAuto(variabledata.numnewcasesctr)
        variabledata.numdiedword = numWord(variabledata.numdiedctr)
        variabledata.numdied = numWordAuto(variabledata.numdiedctr)
        variabledata.numnewdiedword = numWord(variabledata.numnewdiedctr)
        variabledata.numnewdied = numWordAuto(variabledata.numnewdiedctr)
        variabledata.numlocalcasesword = numWord(variabledata.numlocalcasesctr)
        variabledata.numlocalcases = numWordAuto(variabledata.numlocalcasesctr)
        variabledata.numimportedcasesword = numWord(variabledata.numimportedcasesctr)
        variabledata.numimportedcases = numWordAuto(variabledata.numimportedcasesctr)
        variabledata.numrecoveredword = numWord(variabledata.numrecoveredctr)
        variabledata.numrecovered = numWordAuto(variabledata.numrecoveredctr)
        variabledata.numdischargedword = numWord(variabledata.numdischargedctr)
        variabledata.numdischarged = numWordAuto(variabledata.numdischargedctr)
        variabledata.numcriticalword = numWord(variabledata.numcriticalctr)
        variabledata.numcritical = numWordAuto(variabledata.numcriticalctr)
        variabledata.numclustersword = numWord(variabledata.numclustersctr)
        variabledata.numclusters = numWordAuto(variabledata.numclustersctr)
        variabledata.numnoclusterword = numWord(variabledata.numnoclusterctr)
        variabledata.numnocluster = numWordAuto(variabledata.numnoclusterctr)
        variabledata.numnooriginword = numWord(variabledata.numnooriginctr)
        variabledata.numnoorigin = numWordAuto(variabledata.numnooriginctr)
        this.$store.commit('pushResponse', {
          jsonkeydata,
          variabledata
        })
        // replace byline updated date
        setTimeout(() => {
          const formupdateddate = new Date($('.st-byline .lastupdated:first').text().replace(/,|at.*/ig, ''))
          const dataupdateddate = new Date(jsonkeydata[0]['last-updated'].replace(/at.*/, ''))
          if (isNaN(formupdateddate) || formupdateddate <= dataupdateddate) {
            $('.st-byline .lastupdated').text(jsonkeydata[0]['last-updated'])
          }
        })
      })
      .catch(err => { throw err })
    }

    const numWordAuto = function (numstr) {
      if (+numstr >= 10) {
        // digits digits after nine
        return (+numstr).toLocaleString()
      }
      return numWord(numstr)
    }

    const numWord = function (numstr) {
      const arr = x => Array.from(x)
      const num = x => Number(x) || 0
      const isEmpty = xs => xs.length === 0
      const take = n => xs => xs.slice(0, n)
      const drop = n => xs => xs.slice(n)
      const reverse = xs => xs.slice(0).reverse()
      const comp = f => g => x => f(g(x))
      const not = x => !x
      const chunk = n => xs =>
        isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))]

      let numToWords = n => {
        let a = [
          '', 'one', 'two', 'three', 'four',
          'five', 'six', 'seven', 'eight', 'nine',
          'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
          'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
        ]

        let b = [
          '', '', 'twenty', 'thirty', 'forty',
          'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
        ]

        let g = [
          '', 'thousand', 'million', 'billion', 'trillion', 'quadrillion',
          'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion'
        ]

        // this part is really nasty still
        // might edit this again later
        let makeGroup = ([ones, tens, huns]) => {
          return [
            num(huns) === 0 ? '' : a[huns] + ' hundred ',
            num(ones) === 0 ? b[tens] : b[tens] && b[tens] + '-' || '',
            a[tens + ones] || a[ones]
          ].join('')
        }

        let thousand = (group, i) => group === '' ? group : `${group} ${g[i]}`

        if (typeof n === 'number') {
          return numToWords(String(n))
        } else if (n === '0') {
          return 'zero'
        } else {
          return (comp(chunk(3))(reverse)(arr(n))
            .map(makeGroup)
            .map(thousand)
            .filter(comp(not)(isEmpty))
            .reverse()
            .join(' '))
        }
      }
      return numToWords(numstr).trim()
    }

    const replaceVar = function (str = '', data = {}) {
      const reg = /\{\{(.*?)\}\}/
      var found = reg.exec(str)
      const storeState = this.$store.state.variabledata
      while (found) {
        var varArr = found[1].split(':')
        var val = ''
        var numberKey = varArr[0]
        if (varArr[0] in data) {
          val = data[varArr[0]]
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            val += +data[numberKey] > 1 ? varArr[2] : varArr[1]
          }
          str = str.replace(found[0], val)
        } else if (varArr[0] in storeState) {
          // if no data is provided, look in the store variableData
          val = storeState[varArr[0]]
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            val += +storeState[numberKey] > 1 ? varArr[2] : varArr[1]
          }
          str = str.replace(found[0], val)
        } else {
          str = str.replace(found[0], '')
        }
        found = reg.exec(str)
      }
      return str
    }

    Vue.prototype.$replaceVar = replaceVar
    Vue.prototype.$numToWord = numWord
    Vue.prototype.$numToAuto = numWordAuto
    Vue.prototype.$getJsonData = getJsonData
  }
}
